export function personName(person = {}) {
  return person.nickname || person.aliases?.[0] || [person.first_name, person.last_name].filter(Boolean).join(' ') || `Persona ${person.id}`;
}

export function shortDate(value) {
  return value ? String(value).slice(0, 10) : 'Sin límite';
}

export function today() {
  return new Date().toISOString().slice(0, 10);
}

export function optionalId(value) {
  return value ? Number(value) : null;
}
